import { useCallback, useEffect, useState } from "react";

export function useTimer(total) {
  const [elapsed, setElapsed] = useState(0);
  const [running, setRunning] = useState(false);

  useEffect(() => {
    if (!running) return undefined;
    const id = setInterval(() => setElapsed((e) => Math.min(total, e + 0.1)), 100);
    return () => clearInterval(id);
  }, [running, total]);

  useEffect(() => {
    if (elapsed >= total) setRunning(false);
  }, [elapsed, total]);

  const toggle = useCallback(() => {
    setElapsed((e) => (e >= total ? 0 : e));
    setRunning((r) => !r);
  }, [total]);

  const reset = useCallback(() => {
    setElapsed(0);
    setRunning(true);
  }, []);

  return { elapsed, running, toggle, reset };
}
